const apiUrl = process.env.REACT_APP_API_URL;
export const PostRanking = async (json: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/ranking`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(json)
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
